var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"overview-container"},[_c('detailoverviewinfo-nav',{staticClass:"overview-content-left",attrs:{"onchaindata":_vm.onchaindata,"offchaindata":_vm.offchaindata}}),_c('detailmap-nav',{staticClass:"overview-content-right",attrs:{"mapWidth":"440px","mapHeight":"440px"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }